import { CircularProgress } from '@mui/material';
import './loading-page.scss';

export const LoadingPage = () => {
  return (
    <div className="loading-page">
      <CircularProgress style={{ width: '56px', height: '56px' }} />
    </div>
  );
};
